import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper
} from '@mui/material';
import MainCard from '../../components/MainCard';
import Sidebar from "../../menu-items/Sidebar";
import axios from 'axios';
import { MenuItem, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { Autocomplete } from '@mui/material';
import Cookies from 'js-cookie';

const Waitlist = () => {
  const [data, setData] = useState([]); 
  const [page, setPage] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(1000); 
  const [mode, setMode] = useState('user'); // default
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const [consentBundles, setConsentBundles] = useState([]);
  const [selectedConsentBundle, setSelectedConsentBundle] = useState('');

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');

  const [practices, setPractices] = useState([]);
  const [selectedPractice, setSelectedPractice] = useState('');


useEffect(() => {
    const adminToken = Cookies.get('admintoken'); // get token from cookies
    // console.log('Admin token from cookie:', adminToken);

    // if (adminToken) {
    //   axios.defaults.headers.common['Authorization'] = adminToken; // set axios default
    // }
  }, []);


  // fetchConsentBundles
 useEffect(() => {
    const fetchConsentBundles = async () => {
      try {
     const token = axios.defaults.headers.common.Authorization;
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const url = `${baseUrl}admin/dropdown/consent_bundles`;

       const config = {
          headers: {
            Authorization: `${token}`,
          },
        };
        
        const response = await axios.get(url, config);
        setConsentBundles(response.data); // should be an array of { value, label }
      } catch (error) {
        console.error('Error fetching consent bundles:', error);
      }
    };
  
    fetchConsentBundles();
  }, []);

// Fetch practices list
 useEffect(() => {
    const fetchPractices = async () => {
      try {
       const token = axios.defaults.headers.common.Authorization;
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const url = `${baseUrl}admin/dropdown/practices_with_id`;
  
       const config = {
          headers: {
            Authorization: `${token}`,
          },
        };
  
        const response = await axios.get(url, config);
        setPractices(response.data); 
        console.log('Fetched practices:', response.data); 
      } catch (error) {
        console.error('Error fetching practices:', error);
      }
    };
  
    fetchPractices();
  }, []);


// fetchUsers
  useEffect(() => {
    const fetchUsers = async () => {
      try {
         const token = axios.defaults.headers.common.Authorization;
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const url = `${baseUrl}admin/dropdown/users`;

       const config = {
          headers: {
            Authorization: `${token}`,
          },
        };
        
        const response = await axios.get(url, config);
        setUsers(response.data); // should be an array of { value, label }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
  
    fetchUsers();
  }, []);

const [totalCount, setTotalCount] = useState(0);
  const fetchData = async () => {
    const token = axios.defaults.headers.common.Authorization;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const params = new URLSearchParams({
    mode,
    limit: rowsPerPage.toString(),
    offset: (page + 1).toString() // Because backend offset starts at 1
  });

  if (dateFrom) params.append('startDate', dateFrom);
  if (dateTo) params.append('endDate', dateTo);
  if (selectedConsentBundle) params.append('consentBundle', selectedConsentBundle);
  if (selectedUser) params.append('user', selectedUser);
  if (selectedPractice) params.append('practice', selectedPractice);

  const url = `${baseUrl}admin/reports/tracking_report?${params.toString()}`;

  const config = {
          headers: {
            Authorization: `${token}`,
          },
        };

  try {
    const response = await axios.get(url, config);
    setData(response.data.results); // Now reading from results
    setTotalCount(response.data.total); // Needed for pagination
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};


  useEffect(() => {
    setPage(0);
    fetchData();
  }, [mode, dateFrom, dateTo,selectedConsentBundle, selectedUser,selectedPractice]);

  const downloadAsCSV = () => {
    const csvRows = [];
    const headers = ['#', 'practice', 'consent_bundle_code At', 'patient_name', 'session_start_time', 'session_end_time', 'duration', 'status'];
    csvRows.push(headers.join(','));

    data.forEach((row, index) => {
      const rowData = [
        page * rowsPerPage + index + 1,
        row.practice,
        row.consent_bundle_code,
        row.patient_name,
        row.status,
        row.session_start_time,
        row.session_end_time,
        row.duration,
         
      ];
      csvRows.push(rowData.join(','));
    });

    const csvData = csvRows.join('\n');
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Time Tracking Report.csv';
    link.click();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); 
  };

  const displayedData = data;

  return (
    <Box sx={{ border: '1px solid #ccc', padding: 5, height: '100vh' }}>
      <Grid container rowSpacing={2.5} columnSpacing={2.75}>
        <Grid item xs={12} md={3} lg={2}>
          <Sidebar />
        </Grid>

      

        <Grid item xs={12} md={9} lg={10}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: 'bold', 
                          fontSize: '2rem', 
                        }}
                      >
                     Time Tracking - User
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ marginLeft: 2 }}
                        onClick={downloadAsCSV}
                      >
                        Download as CSV
                      </Button>
                      
                    </Box>

        <Box sx={{ display: 'flex', gap: 2, mt: 2 ,mb: 4, flexWrap: 'wrap', alignItems: 'center' }}>
               
            <Autocomplete
              options={consentBundles}
              getOptionLabel={(option) => option.label || ''}
              value={consentBundles.find((bundle) => bundle.value === selectedConsentBundle) || null}
              onChange={(event, newValue) => setSelectedConsentBundle(newValue ? newValue.value : '')}
              renderInput={(params) => (
                <TextField {...params} label="Consent Bundle" size="small" sx={{ minWidth: 250 }} />
              )}
              isOptionEqualToValue={(option, value) => option.value === value.value}
            />

            <Autocomplete
                options={[{ label: 'All', value: '' }, ...users]}
                getOptionLabel={(option) => option.label || ''}
                value={users.find((user) => user.value === selectedUser) || { label: 'All', value: '' }}
                onChange={(event, newValue) => setSelectedUser(newValue ? newValue.value : '')}
                renderInput={(params) => (
                  <TextField {...params} label="Clinician" size="small" sx={{ minWidth: 250 }} />
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
              />

              {/* <Autocomplete
                options={[{ label: 'All', value: '' }, ...users]}
                getOptionLabel={(option) => option.label || ''}
                value={users.find((user) => user.value === selectedUser) || { label: 'All', value: '' }}
                onChange={(event, newValue) => setSelectedUser(newValue ? newValue.value : '')}
                renderInput={(params) => (
                  <TextField {...params} label="Patients" size="small" sx={{ minWidth: 250 }} />
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
              /> */}

                <Autocomplete
                  options={[{ label: 'All', value: '' }, ...practices]}
                  getOptionLabel={(option) => option.label || ''}
                  value={practices.find((practice) => practice.value === selectedPractice) || { label: 'All', value: '' }}
                  onChange={(event, newValue) => setSelectedPractice(newValue ? newValue.value : '')}
                  renderInput={(params) => (
                    <TextField {...params} label="Practice" size="small" sx={{ minWidth: 250 }} />
                  )}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                />

                <TextField
                  label="Date From"
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                />

                <TextField
                  label="Date To"
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                />

                <Button variant="contained" onClick={fetchData} size="small">
                  Apply Filters
                </Button>

                {(dateFrom || dateTo || consentBundles || practices||users)  && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      setDateFrom('');
                      setDateTo('');
                      fetchData();
                      setSelectedConsentBundle('');
                      setSelectedUser('');
                      setSelectedPractice('');
                    }}
                    size="small"
                  >
                    Clear Filters
                  </Button>
                )}
              </Box>

          <MainCard title="">
            <TablePagination
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={totalCount} 
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

            <TableContainer
              component={Paper}
              sx={{
                borderRadius: '15px', 
                boxShadow: 3, 
                overflow: 'hidden', 
                marginTop: 2,
              }}
            >
              <Table sx={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#1976d2', color: '#fff' }}>
                    <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell> 
                    
                    <TableCell sx={{ fontWeight: 'bold' }}>Consent bundle code</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>User email</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Practice</TableCell>
                 
                    
                    <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Session start time</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Session end time </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Duration</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
              {displayedData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                displayedData.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                      },
                      borderBottom: '1px solid #ddd', 
                    }}
                  >
                    <TableCell sx={{ borderTopLeftRadius: index === 0 ? '15px' : '0px' }}>
                      {page * rowsPerPage + index + 1} 
                    </TableCell>
                    <TableCell>{row.consent_bundle_code}</TableCell>
                    <TableCell>{row.user_email}</TableCell>
                    <TableCell> {row.practice} </TableCell>
                    <TableCell>{row.status}</TableCell>
                    <TableCell>{row.session_start_time}</TableCell>
                    <TableCell>{row.session_end_time}</TableCell>
                    <TableCell>{row.duration}</TableCell>
                    
                  </TableRow>
                ))
              )}
            </TableBody>

              </Table>
            </TableContainer>

          <TablePagination
            rowsPerPageOptions={[50, 100, 200]}
            component="div"
            count={totalCount} // not data.length
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          </MainCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Waitlist;
